/** Stripe Publishable Key */
export const stripePublishableKey =
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY ||
  "pk_live_51RKNIYRo5rtjEMiwJmiXuTxjRsLL3egH2oCgaiNNtSF5t1zlqFylAlGVvPQJaYO9P6SbRICFn0iczqMc2nHqrH5m00NbLvHnwP";

/** Stripe Price IDs — base, maintenance, support (monthly & 3-year prepay). */

export const stripePriceIds: Record<string, string> = {
  small: "price_1UGyc5Ro5rtjEMiw2qCYazpK",
  medium: "price_1UGz2pRo5rtjEMiw9bNX9GxM",
  "large-medium": "price_1UGzMMRo5rtjEMiwAih8DU2S",
  large: "price_1UGzlwRo5rtjEMiw8JyIPI3g",
};

export const stripePriceIdsPrepay3Year: Record<string, string> = {
  small: "price_1UGyqZRo5rtjEMiwn9nsXsSJ",
  medium: "price_1UGzEhRo5rtjEMiwsIgEiALL",
  "large-medium": "price_1UGzg1Ro5rtjEMiwSX3ibCHb",
  large: "price_1UGzx3Ro5rtjEMiw20c8R1Mf",
};

export const stripeMaintenancePriceIds: Record<string, string> = {
  small: "price_1UGyeuRo5rtjEMiwIau9Oyw5",
  medium: "price_1UGz4hRo5rtjEMiwYjPcDzMj",
  "large-medium": "price_1UGzNVRo5rtjEMiwClslSboS",
  large: "price_1UGzmuRo5rtjEMiweQHM4Hao",
};

export const stripeMaintenancePriceIdsPrepay3Year: Record<string, string> = {
  small: "price_1UGyy3Ro5rtjEMiwI8XpabGw",
  medium: "price_1UGzH3Ro5rtjEMiwwps2DAVz",
  "large-medium": "price_1UGzhWRo5rtjEMiwtsdoecxc",
  large: "price_1UGzzKRo5rtjEMiwdEabBKeW",
};

export const stripeSupportPriceIds: Record<string, string> = {
  small: "price_1UGyiARo5rtjEMiw1Jt0KNui",
  medium: "price_1UGz6gRo5rtjEMiwheX1z8f1",
  "large-medium": "price_1UGzOXRo5rtjEMiwJ5Dvh41t",
  large: "price_1UGzniRo5rtjEMiwssGUue1j",
};

export const stripeSupportPriceIdsPrepay3Year: Record<string, string> = {
  small: "price_1UGyzuRo5rtjEMiw1SGebSgg",
  medium: "price_1UGzI3Ro5rtjEMiwHpe4bmC9",
  "large-medium": "price_1UGzj7Ro5rtjEMiwP9VpdoyC",
  large: "price_1UH00nRo5rtjEMiwMUlnNEM6",
};

/** Stripe Product IDs for reference */
export const stripeProductIds = {
  small: {
    monthly: "prod_VHXhxccXH9gWFN",
    monthlyMaintenance: "prod_VHXk7INvXWLNwR",
    monthlySupport: "prod_VHXnUU03WFO5My",
    prepay3Year: "prod_VHXw2TuJLLncIo",
    prepay3YearMaintenance: "prod_VHY4RD6N5GOgq5",
    prepay3YearSupport: "prod_VHY68z8uDxc4s6",
  },
  medium: {
    monthly: "prod_VHY9pctYkX4Ehp",
    monthlyMaintenance: "prod_VHYBXSgnGOnc5t",
    monthlySupport: "prod_VHYDBlntlaF89r",
    prepay3Year: "prod_VHYLMxLEiSqYZB",
    prepay3YearMaintenance: "prod_VHYNsFRyFYgTvM",
    prepay3YearSupport: "prod_VHYOZNVt08Dsdj",
  },
  "large-medium": {
    monthly: "prod_VHYT4XVUT7s6l4",
    monthlyMaintenance: "prod_VHYUZBqvfO4RjK",
    monthlySupport: "prod_VHYVg4DQl2RfSY",
    prepay3Year: "prod_VHYnxpnC5sOUlp",
    prepay3YearMaintenance: "prod_VHYpWzclcmNTcw",
    prepay3YearSupport: "prod_VHYqVsFm0aM7Iu",
  },
  large: {
    monthly: "prod_VHYtZbXDGYtpob",
    monthlyMaintenance: "prod_VHYumpMRSpJpx4",
    monthlySupport: "prod_VHYvmebh0Gs7iX",
    prepay3Year: "prod_VHZ5SfKpCzezYE",
    prepay3YearMaintenance: "prod_VHZ7EO8QUcovlT",
    prepay3YearSupport: "prod_VHZ9G50YDZgR8O",
  },
} as const;
